(function () {
  'use strict';
  if (window.MDCCartSavings) return;
  // Shopify can split identical qualifying units for the automatic gift discount.
  // Group their presentation only; retain Shopify's line keys and discount data.
  var mdcCartLineGroups = new Map();
  var mdcCartLineHidden = [];
  var mdcCartLineBusy = false;
  var giftChoiceFlight = null;
  var giftChoiceFailure = null;
  var giftChoiceCart = null;
  var giftChoiceAttribute = 'mdc_gift_opt_out';
  function giftChoiceLines(cart) {
    return (cart && Array.isArray(cart.items) ? cart.items : []).filter(function (item) {
      return String(item.variant_id) === '54520301977918' &&
        item.properties?.__essential_cart_drawer_reward_tier_id === '1978a3c9-d4c4-46cb-9d1e-1c489ea30ae1';
    });
  }
  function giftChoiceDeclined(cart) {
    return cart?.gift_opt_out === true || cart?.attributes?.[giftChoiceAttribute] === '1';
  }
  function giftChoiceWords() {
    return ({ en: ['Remove gift', 'Removing gift…', 'Could not remove the gift. Please try again.'],
      es: ['Quitar el regalo', 'Eliminando el regalo…', 'No se pudo quitar el regalo. Inténtalo de nuevo.'],
      ar: ['إزالة الهدية', 'جارٍ إزالة الهدية…', 'تعذرت إزالة الهدية. يرجى المحاولة مجددًا.']
    })[document.documentElement.lang.slice(0, 2)] || ['Retirer le cadeau', 'Retrait du cadeau…', 'Le retrait a échoué. Veuillez réessayer.'];
  }
  function giftChoiceSignature(cart) {
    return giftChoiceLines(cart).map(function (item) { return item.key + ':' + item.quantity; }).sort().join('|');
  }
  function giftChoicePresent(cart) {
    giftChoiceCart = cart;
    var gifts = giftChoiceLines(cart);
    var portal = document.getElementById('essential-cart-drawer-portal');
    if (portal) portal.querySelectorAll('[data-essential-cart-element="cart-drawer-item"]').forEach(function (row) {
      var link = row.querySelector('a[data-essential-cart-element="line-item-title"]');
      if (!link || mdcGiftBadgeVariant(link.getAttribute('href'), document.baseURI) !== '54520301977918') return;
      var actions = row.querySelector('[data-essential-cart-element="line-item-actions"]');
      if (!actions) return;
      var button = actions.querySelector('[data-mdc-gift-remove]');
      var actualRemove = actions.querySelector('[data-essential-cart-element="line-item-remove"]');
      if (!gifts.length || actualRemove) { if (button) button.remove(); return; }
      if (!button) {
        button = document.createElement('button');
        button.type = 'button'; button.dataset.mdcGiftRemove = '';
        button.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;color:#616161;background:transparent;border:0;width:32px;min-height:44px;padding:0;cursor:pointer;';
        button.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" aria-hidden=\"true\"><path d=\"M11.5 8.25C11.9142 8.25 12.25 8.58579 12.25 9V13.25C12.25 13.6642 11.9142 14 11.5 14C11.0858 14 10.75 13.6642 10.75 13.25V9C10.75 8.58579 11.0858 8.25 11.5 8.25Z\" fill=\"#616161\"></path><path d=\"M9.25 9C9.25 8.58579 8.91421 8.25 8.5 8.25C8.08579 8.25 7.75 8.58579 7.75 9V13.25C7.75 13.6642 8.08579 14 8.5 14C8.91421 14 9.25 13.6642 9.25 13.25V9Z\" fill=\"#616161\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.24994 5.25C7.24994 3.73122 8.48116 2.5 9.99994 2.5C11.5187 2.5 12.7499 3.73122 12.7499 5.25H15.75C16.1642 5.25 16.5 5.58579 16.5 6C16.5 6.41421 16.1642 6.75 15.75 6.75H14.9999L14.9998 12.2001C14.9998 13.8802 14.9997 14.7203 14.6728 15.362C14.3851 15.9265 13.9262 16.3854 13.3617 16.673C12.72 17 11.8799 17 10.1997 17H9.79999C8.11978 17 7.27968 17 6.63793 16.673C6.07343 16.3854 5.61448 15.9264 5.32687 15.3619C4.99989 14.7202 4.9999 13.8801 4.99994 12.1999L5.00005 6.75H4.25C3.83579 6.75 3.5 6.41421 3.5 6C3.5 5.58579 3.83579 5.25 4.25 5.25H7.24994ZM8.74994 5.25C8.74994 4.55964 9.30958 4 9.99994 4C10.6903 4 11.2499 4.55964 11.2499 5.25H8.74994ZM6.50007 6.75H13.4999L13.4998 12.2001C13.4998 13.0649 13.4986 13.6233 13.4639 14.0483C13.4305 14.4558 13.374 14.6068 13.3362 14.681C13.1924 14.9632 12.963 15.1927 12.6807 15.3365C12.6065 15.3743 12.4555 15.4308 12.048 15.4641C11.623 15.4988 11.0646 15.5 10.1997 15.5H9.79999C8.93513 15.5 8.37671 15.4988 7.95169 15.4641C7.54418 15.4308 7.3931 15.3743 7.31893 15.3365C7.03668 15.1927 6.80721 14.9632 6.6634 14.681C6.62561 14.6068 6.56909 14.4557 6.53581 14.0482C6.50109 13.6232 6.49994 13.0648 6.49995 12.1999L6.50007 6.75Z\" fill=\"#616161\"></path></svg>";
        actions.style.cssText = 'flex:0 0 124px;width:124px;justify-content:flex-start;';
        var priceRow = actions.parentElement;
        priceRow.style.cssText = 'width:100%;flex-direction:row;align-items:center!important;gap:0;';
        actions.append(button);
      }
      var label = giftChoiceWords()[giftChoiceFlight ? 1 : 0];
      button.setAttribute('aria-label', label);
      button.title = label;
      button.setAttribute('aria-busy', String(!!giftChoiceFlight));
      button.disabled = !!giftChoiceFlight;
    });
    if (giftChoiceDeclined(cart) && gifts.length && !giftChoiceFlight && giftChoiceFailure !== giftChoiceSignature(cart)) {
      removeOptionalGift(false).catch(function () {});
    }
  }
  function removeOptionalGift(explicit) {
    if (giftChoiceFlight) return giftChoiceFlight;
    if (mdcCartLineBusy) return Promise.reject(new Error('Cart update in progress'));
    giftChoiceFlight = (async function () {
      var cart = await readSnapshot();
      if (!explicit && !giftChoiceDeclined(cart)) return;
      var gifts = giftChoiceLines(cart);
      if (!gifts.length && giftChoiceDeclined(cart)) return;
      if (!gifts.length) throw new Error('Gift unavailable');
      if (typeof cart.cart_url !== 'string' || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart$/.test(cart.cart_url)) throw new Error('Invalid cart route');
      var updates = {};
      gifts.forEach(function (item) { updates[item.key] = 0; });
      var sections = Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map(function (node) { return node.dataset.sectionId; }))).slice(0, 4);
      sections.push('mdc-cart-savings-data');
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 15000);
      var updated;
      try {
        var response = await fetch(cart.cart_url + '/update.js', {
          method: 'POST', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates, attributes: { [giftChoiceAttribute]: '1' }, sections: sections, sections_url: location.pathname })
        });
        updated = await response.json();
        if (!response.ok || updated.errors || !Array.isArray(updated.items) || !giftChoiceDeclined(updated) || giftChoiceLines(updated).length) throw new Error('Gift removal unconfirmed');
      } finally { clearTimeout(timeout); }
      giftChoiceFailure = null;
      var api = window.essentialCartApi;
      if (api && typeof api.refreshCart === 'function') await api.refreshCart();
      var events = await import('@shopify/events');
      document.dispatchEvent(new events.CartLinesUpdateEvent({
        action: 'remove', context: 'cart', lines: gifts.map(function (item) { return { id: item.key, quantity: 0 }; }),
        promise: Promise.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(updated),
          detail: { items: updated.items, itemCount: updated.item_count, source: 'mdc-gift-choice', didError: false } })
      }));
      document.dispatchEvent(new CustomEvent('mdc:cart-updated'));
    }()).catch(function (error) {
      giftChoiceFailure = giftChoiceSignature(giftChoiceCart);
      var button = document.querySelector('[data-mdc-gift-remove]');
      if (button) {
        var message = button.parentElement.querySelector('[data-mdc-gift-error]');
        if (!message) { message = document.createElement('span'); message.dataset.mdcGiftError = ''; message.setAttribute('role', 'alert'); button.after(message); }
        message.textContent = giftChoiceWords()[2];
      }
      throw error;
    }).finally(function () { giftChoiceFlight = null; refresh(); });
    return giftChoiceFlight;
  }
  window.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('[data-mdc-gift-remove],.cart-items__remove');
    if (!button) return;
    var nativeRow = button.closest('tr[data-key]');
    var gifts = giftChoiceLines(giftChoiceCart);
    var matchesGift = button.hasAttribute('data-mdc-gift-remove') ||
      (nativeRow && gifts.some(function (item) { return item.key === nativeRow.dataset.key; }));
    if (!matchesGift) return;
    event.preventDefault(); event.stopImmediatePropagation();
    giftChoiceFailure = null;
    removeOptionalGift(true).catch(function () {});
    giftChoicePresent(giftChoiceCart);
  }, true);
  window.MDCGiftChoice = { remove: removeOptionalGift, pending: function () { return giftChoiceFlight; } };

  function mdcCartLineGroup(cart, variant) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var items = cart.items.filter(function (item) { return String(item.variant_id) === String(variant); });
    if (!items.length || !items.every(function (item) {
      return String(item.product_id) === String(items[0].product_id) && item.grouping_eligible === true &&
        Number.isSafeInteger(item.quantity) && item.quantity > 0 && typeof item.key === 'string' &&
        Number.isSafeInteger(item.original_price) && item.original_price > 0 &&
        item.original_price === items[0].original_price &&
        item.compare_at_price === items[0].compare_at_price &&
        item.final_line_price === item.original_price * item.quantity;
    }) || new Set(items.map(function (item) { return item.key; })).size !== items.length) return null;
    return { variant: String(variant), items: items, quantity: items.reduce(function (sum, item) { return sum + item.quantity; }, 0) };
  }
  function mdcCartLineQuantityRequest(group, quantity, cart, exclusions) {
    if (!group || !Number.isSafeInteger(quantity) || quantity < 0) throw new Error('Invalid quantity');
    var delta = quantity - group.quantity;
    if (delta > 0) return { route: '/change.js', body: { id: group.items[0].key, quantity: group.items[0].quantity + delta } };
    var remaining = -delta;
    var updates = {};
    group.items.slice().reverse().forEach(function (item) {
      var remove = Math.min(remaining, item.quantity);
      if (remove) updates[item.key] = item.quantity - remove;
      remaining -= remove;
    });
    if (quantity === 0 && cart && Array.isArray(cart.items)) {
      var removed = new Set(group.items.map(function (item) { return item.key; }));
      var excluded = new Set((exclusions || []).map(String).concat(['12602893959486']));
      var hasMerchandise = cart.items.some(function (item) {
        return !removed.has(item.key) && item.quantity > 0 &&
          !item.properties?.__essential_cart_drawer_reward_tier_id && !excluded.has(String(item.product_id));
      });
      if (!hasMerchandise) cart.items.forEach(function (item) {
        if (item.properties?.__essential_cart_drawer_reward_tier_id || String(item.product_id) === '12602893959486') updates[item.key] = 0;
      });
    }
    return { route: '/update.js', body: { updates: updates } };
  }
  function mdcCartLineRestore() {
    document.querySelectorAll('[data-mdc-cart-line-group]').forEach(function (node) { node.remove(); });
    mdcCartLineHidden.forEach(function (entry) {
      if (entry.display) entry.row.style.setProperty('display', entry.display, entry.priority);
      else entry.row.style.removeProperty('display');
      entry.row.hidden = entry.hidden;
    });
    mdcCartLineHidden = [];
    mdcCartLineGroups.clear();
  }
  async function mdcCartLineChange(variant, quantity, nextVariant, allowedVariants) {
    if (mdcCartLineBusy || giftChoiceFlight) return;
    mdcCartLineBusy = true;
    var reloading = false;
    var owned = Array.from(document.querySelectorAll('[data-mdc-cart-line-group]'));
    owned.forEach(function (row) { row.setAttribute('aria-busy', 'true'); row.querySelectorAll('button,input,select').forEach(function (node) { node.disabled = true; }); });
    try {
      var cart = await readSnapshot();
      var group = mdcCartLineGroup(cart, variant);
      if (!group) throw new Error('Cart changed');
      var request;
      if (nextVariant) {
        if (!Array.isArray(allowedVariants) || !allowedVariants.includes(String(nextVariant)) || !/^\d+$/.test(String(nextVariant))) throw new Error('Invalid variant');
        var other = cart.items.filter(function (item) { return String(item.variant_id) === String(nextVariant); });
        var destination = other.length ? mdcCartLineGroup(cart, nextVariant) : null;
        if (other.length && (!destination || String(destination.items[0].product_id) !== String(group.items[0].product_id))) throw new Error('Cart changed');
        var updates = {};
        group.items.forEach(function (item) { updates[item.key] = 0; });
        if (destination) updates[destination.items[0].key] = destination.items[0].quantity + group.quantity;
        else updates[nextVariant] = group.quantity;
        request = { route: '/update.js', body: { updates: updates } };
      } else {
        var offers = window.MDCCartSavingsConfig?.gifts;
        var offer = offers?.length === 1 && offers[0].rulesVerified && offers[0].automaticTitleVerified ? offers[0] : null;
        request = mdcCartLineQuantityRequest(group, quantity, cart, offer?.excludedProductIds);
      }
      if (typeof cart.cart_url !== 'string' || !/^\/(?:[a-z]{2}\/)?cart$/.test(cart.cart_url)) throw new Error('Invalid cart route');
      var response = await fetch(cart.cart_url + request.route, {
        method: 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(request.body)
      });
      var updated = await response.json();
      if (!response.ok || updated.errors || updated.status >= 400 || !Array.isArray(updated.items)) throw new Error('Quantity update failed');
      if (document.querySelector('main .cart-page, main cart-items-component')) { reloading = true; window.location.reload(); return; }
      var api = window.essentialCartApi;
      if (api && typeof api.refreshCart === 'function') await api.refreshCart();
      document.dispatchEvent(new CustomEvent('mdc:cart-updated'));
      await refresh();
    } catch (_) {
      await refresh().catch(function () {});
      var row = document.querySelector('[data-mdc-cart-line-group]');
      if (row) {
        var error = document.createElement('p'); error.setAttribute('role', 'alert');
        error.textContent = ({ en: 'Please refresh the cart before changing this quantity.', es: 'Actualiza el carrito antes de cambiar esta cantidad.', ar: 'يرجى تحديث السلة قبل تغيير الكمية.' })[document.documentElement.lang.slice(0,2)] || 'Actualisez le panier avant de modifier cette quantité.';
        row.append(error);
      }
    } finally {
      mdcCartLineBusy = false;
      if (!reloading) await refresh().catch(function () {});
    }
  }
  function mdcCartLinePresent(cart) {
    if (observer) observer.disconnect();
    try {
      mdcCartLineRestore();
      Array.from(new Set((cart?.items || []).map(function (item) { return String(item.variant_id); }))).forEach(function (variant) {
        var group = mdcCartLineGroup(cart, variant);
        if (!group || group.items.length < 2) return;
        var portal = document.querySelector('#essential-cart-drawer-portal');
        var drawerRows = portal ? Array.from(portal.querySelectorAll('[data-essential-cart-element="cart-drawer-item-details"]')).filter(function (details) {
          var link = details.querySelector('a[data-essential-cart-element="line-item-title"]');
          return link && mdcGiftBadgeVariant(link.getAttribute('href'), document.baseURI) === variant;
        }).map(function (details) { return details.closest('[data-essential-cart-element="cart-drawer-item"]').parentElement; }) : [];
        var pageRows = Array.from(document.querySelectorAll('cart-items-component tr[data-product-id][data-key]')).filter(function (row) { return group.items.some(function (item) { return item.key === row.dataset.key; }); });
        [drawerRows, pageRows].forEach(function (rows) {
          if (rows.length !== group.items.length || !rows.every(function (row) { return row.parentElement === rows[0].parentElement; })) return;
          var clone = rows[0].cloneNode(true);
          clone.setAttribute('data-mdc-cart-line-group', variant);
          clone.removeAttribute('hidden'); clone.style.removeProperty('display');
          [clone].concat(Array.from(clone.querySelectorAll('*'))).forEach(function (node) {
            Array.from(node.attributes).forEach(function (attr) { if (attr.name === 'id' || attr.name === 'ref' || attr.name.startsWith('on:')) node.removeAttribute(attr.name); });
          });
          clone.querySelectorAll('[data-essential-cart-element="line-item-discounts"], .cart-items__discounts').forEach(function (node) { node.remove(); });
          var selector = clone.querySelector('cart-quantity-selector-component');
          if (selector) { var plain = document.createElement('div'); plain.className = selector.className; plain.innerHTML = selector.innerHTML; selector.replaceWith(plain); }
          var frame = clone.querySelector('[data-essential-cart-element="cart-drawer-item-frame"]');
          if (frame) frame.setAttribute('aria-label', frame.getAttribute('aria-label').replace(/\d+\s*$/, String(group.quantity)));
          clone.querySelectorAll('input').forEach(function (node) { node.removeAttribute('name'); node.removeAttribute('form'); });
          var input = clone.querySelector('input[name="updates[]"],input[type="number"]');
          var value = clone.querySelector('[data-essential-cart-element="quantity-value"]');
          if (value) value.textContent = String(group.quantity);
          if (input) { input.value = String(group.quantity); input.defaultValue = String(group.quantity); input.addEventListener('change', function (event) { event.stopImmediatePropagation(); mdcCartLineChange(variant, Number(input.value)); }, true); }
          var minus = clone.querySelector('[data-essential-cart-element="quantity-decrement"],button[name="minus"]');
          var plus = clone.querySelector('[data-essential-cart-element="quantity-increment"],button[name="plus"]');
          var remove = clone.querySelector('[data-essential-cart-element="line-item-remove"],.cart-items__remove');
          [[minus, group.quantity - 1], [plus, group.quantity + 1], [remove, 0]].forEach(function (entry) {
            if (!entry[0]) return;
            entry[0].disabled = mdcCartLineBusy || (entry[0] === minus && group.quantity <= 1);
            entry[0].addEventListener('click', function (event) { event.preventDefault(); event.stopImmediatePropagation(); mdcCartLineChange(variant, entry[1]); }, true);
          });
          var select = clone.querySelector('select');
          if (select) { var allowedVariants = Array.from(select.options).filter(function (option) { return !option.disabled; }).map(function (option) { return option.value; }); select.value = variant; select.addEventListener('change', function (event) { event.stopImmediatePropagation(); mdcCartLineChange(variant, group.quantity, select.value, allowedVariants); }, true); }
          var format = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: cart.currency });
          var price = clone.querySelector('[data-essential-cart-element="line-item-discounted-price"],.cart-items__price text-component');
          var regular = clone.querySelector('[data-essential-cart-element="line-item-regular-price"]');
          var total = group.items.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
          if (price) { price.textContent = format.format(total / 100); if (price.tagName === 'TEXT-COMPONENT') price.setAttribute('value', price.textContent); }
          var regularTotal = Math.max(Number(group.items[0].compare_at_price) || 0, group.items[0].original_price) * group.quantity;
          if (regular) regular.textContent = format.format(regularTotal / 100);
          clone.querySelectorAll('[data-essential-cart-element="line-item-price"] > span[translate="no"]').forEach(function (node, index) { node.textContent = node.textContent.replace(/[\d\s\u00a0\u202f.,]+[^:]*$/, '') + ' ' + format.format((index ? total : regularTotal) / 100); });
          rows.forEach(function (row) { mdcCartLineHidden.push({ row: row, hidden: row.hidden, display: row.style.getPropertyValue('display'), priority: row.style.getPropertyPriority('display') }); row.hidden = true; row.style.setProperty('display', 'none', 'important'); });
          rows[0].before(clone);
          mdcCartLineGroups.set(clone, group);
        });
      });
    } finally { if (observer) observer.observe(document.body, { childList: true, subtree: true, characterData: true }); }
  }

  var result = null;
  var pending = true;
  var timer;
  var protectionCleanup = false;
  var protectionAttempt = null;
  function mdcHasOnlyZeroGiftAllocations(cart, variantId, title) {
    // Compare the app's unchanged allocation title after localizing its display badge.
    title = ({ 'Gift with purchase': 'Cadeau offert avec achat', 'Regalo con compra': 'Cadeau offert avec achat', 'هدية مع الشراء': 'Cadeau offert avec achat' })[title] || title;
    if (!cart || !Array.isArray(cart.items) || !/^\d+$/.test(String(variantId))) return false;
    if (title !== 'Offre cadeau' && title !== 'Cadeau offert avec achat') return false;
    var items = cart.items.filter(function (item) { return item && String(item.variant_id) === String(variantId); });
    if (!items.length) return false;
    var found = false;
    return items.every(function (item) {
      var all = item.discount_allocations;
      var line = item.line_level_discount_allocations;
      if (all !== undefined && !Array.isArray(all) || line !== undefined && !Array.isArray(line)) return false;
      if (!Array.isArray(all) && !Array.isArray(line)) return false;
      var allocations = (all || []).concat(line || []);
      return allocations.every(function (allocation) {
        if (!allocation || !allocation.discount_application) return false;
        if (allocation.discount_application.title !== title) return true;
        found = true;
        return Number.isSafeInteger(allocation.amount) && allocation.amount === 0;
      });
    }) && found;
  }
  function mdcGiftBadgeVariant(href, baseUrl) {
    try {
      var url = new URL(href, baseUrl);
      if (url.origin !== new URL(baseUrl).origin || !/^\/(?:(?:en|es|ar)\/)?products\/[^/]+$/.test(url.pathname)) return null;
      var variants = url.searchParams.getAll('variant');
      return variants.length === 1 && /^\d+$/.test(variants[0]) ? variants[0] : null;
    } catch (_) { return null; }
  }
  var mdcHiddenGiftBadges = new WeakMap(); var mdcGiftBadgeCart = null;
  function mdcUpdateGiftDiscountBadges(cart, portal) {
    if (!portal) return;
    portal.querySelectorAll('[data-essential-cart-element="line-item-discounts"]').forEach(function (badge) {
      var details = badge.closest('[data-essential-cart-element="cart-drawer-item-details"]');
      var links = details ? details.querySelectorAll('a[data-essential-cart-element="line-item-title"]') : [];
      var title = badge.textContent.trim().replace(/\s+/g, ' ');
      var variantId = links.length === 1 ? mdcGiftBadgeVariant(links[0].getAttribute('href'), badge.ownerDocument.baseURI) : null;
      var shouldHide = Boolean(variantId && mdcHasOnlyZeroGiftAllocations(cart, variantId, title));
      var saved = mdcHiddenGiftBadges.get(badge);
      var display = badge.style.getPropertyValue('display');
      var priority = badge.style.getPropertyPriority('display');
      var ownsDisplay = display === 'none' && priority === 'important';
      if (shouldHide) {
        if (!saved && !badge.hidden) {
          saved = { hidden: badge.hidden, display: display, priority: priority };
          mdcHiddenGiftBadges.set(badge, saved);
        } else if (saved && !ownsDisplay) {
          saved.display = display;
          saved.priority = priority;
        }
        if (saved) {
          badge.hidden = true;
          badge.style.setProperty('display', 'none', 'important');
        }
      } else if (saved) {
        if (ownsDisplay) {
          if (saved.display) badge.style.setProperty('display', saved.display, saved.priority);
          else badge.style.removeProperty('display');
        }
        badge.hidden = saved.hidden;
        mdcHiddenGiftBadges.delete(badge);
      }
    });
  }
  async function cleanOrphanedProtection(cart) {
    if (!document.body.classList.contains('mdc-cart-v1') || protectionCleanup) return;
    var updates = window.MDCCartSavingsModel.protectionRemovalUpdates(cart);
    if (!updates) {
      if (result?.valid && !pending && document.querySelector('[data-mdc-protection-blocked]') &&
          !cart.items.some(function (item) { return String(item.product_id) === '12602893959486'; })) {
        protectionCleanup = true;
        window.location.reload();
      }
      return;
    }
    var signature = JSON.stringify(updates);
    if (signature === protectionAttempt) return;
    protectionAttempt = signature;
    protectionCleanup = true;
    try {
      if (typeof cart.cart_url !== 'string' || !cart.cart_url.startsWith('/') || cart.cart_url.startsWith('//')) throw new Error('Invalid cart route');
      var response = await fetch(cart.cart_url + '/update.js', {
        method: 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      var updated = await response.json();
      if (!response.ok || updated.errors || !Array.isArray(updated.items) ||
          updated.items.some(function (item) { return String(item.product_id) === '12602893959486'; })) {
        throw new Error('Protection cleanup failed');
      }
      window.location.reload();
    } catch (_) {
      protectionCleanup = false;
      document.querySelectorAll('[data-mdc-protection-status]').forEach(function (node) {
        node.textContent = node.dataset.errorLabel;
        node.hidden = false;
      });
    }
  }
  function panels() { return document.querySelectorAll('#essential-cart-drawer-portal [data-mdc-cart-savings]'); }
  function summaryLabels() {
    return ({
      en: { subtotal: 'Subtotal', total: 'Total to pay', other: 'Other discounts' },
      es: { subtotal: 'Subtotal', total: 'Total a pagar', other: 'Otros descuentos' },
      ar: { subtotal: 'المجموع الفرعي', total: 'الإجمالي للدفع', other: 'خصومات أخرى' }
    })[document.documentElement.lang.slice(0, 2)] ||
      { subtotal: 'Sous-total', total: 'Total à payer', other: 'Autres réductions' };
  }
  function render() {
    panels().forEach(function (panel) {
      panel.hidden = !result || !result.valid || !result.complete || !Number.isSafeInteger(result.checkoutTotal) || result.beforeReductionTotal <= 0;
      var footer = panel.closest('[data-essential-cart-element="cart-drawer-footer"]');
      if (footer) footer.toggleAttribute('data-mdc-savings-managed', !panel.hidden);
      panel.setAttribute('aria-busy', pending ? 'true' : 'false');
      panel.querySelectorAll('.mdc-cart-savings__code').forEach(function (row) {
        if (panel.hidden) row.remove();
      });
      if (panel.hidden) return;
      var line = panel.querySelector('.mdc-cart-savings__total');
      if (!line) {
        line = document.createElement('div');
        line.className = 'mdc-cart-savings__row mdc-cart-savings__total';
        line.append(document.createElement('span'), document.createElement('strong'));
        panel.replaceChildren(line);
      }
      var format = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: result.currency });
      var labels = summaryLabels();
      var label = labels.total;
      var value = format.format(result.checkoutTotal / 100);
      var name = line.querySelector('span');
      var amount = line.querySelector('strong');
      if (name.textContent !== label) name.textContent = label;
      if (amount.textContent !== value) amount.textContent = value;
      var beforeLine = panel.querySelector('.mdc-cart-savings__before');
      if (!beforeLine) {
        beforeLine = document.createElement('div');
        beforeLine.className = 'mdc-cart-savings__row mdc-cart-savings__before';
        beforeLine.append(document.createElement('span'), document.createElement('strong'));
        panel.prepend(beforeLine);
      }
      var beforeName = beforeLine.querySelector('span');
      var beforeAmount = beforeLine.querySelector('strong');
      beforeLine.hidden = result.paidDiscountTotal <= 0;
      var beforeLabel = labels.subtotal;
      var beforeValue = format.format(result.beforeReductionTotal / 100);
      if (beforeName.textContent !== beforeLabel) beforeName.textContent = beforeLabel;
      if (beforeAmount.textContent !== beforeValue) beforeAmount.textContent = beforeValue;
      var codeSavings = Array.isArray(result.codeSavings) ? result.codeSavings.filter(function (code) { return code && typeof code.code === 'string' && code.code.trim() && Number.isSafeInteger(code.amount) && code.amount > 0; }) : [];
      var codeTotal = codeSavings.reduce(function (sum, code) { return sum + code.amount; }, 0);
      if (codeTotal > result.paidDiscountTotal) { codeSavings = []; codeTotal = 0; }
      if (result.paidDiscountTotal > codeTotal) codeSavings.push({ code: labels.other, amount: result.paidDiscountTotal - codeTotal });
      var codeRows = panel.querySelectorAll('.mdc-cart-savings__code'); codeSavings.forEach(function (code, index) { var codeLine = codeRows[index]; if (!codeLine) { codeLine = document.createElement('div'); codeLine.className = 'mdc-cart-savings__row mdc-cart-savings__code'; codeLine.append(document.createElement('span'), document.createElement('strong')); line.before(codeLine); } var codeName = codeLine.querySelector('span'); var codeAmount = codeLine.querySelector('strong'); var codeValue = format.format(-code.amount / 100); if (codeName.textContent !== code.code) codeName.textContent = code.code; if (codeAmount.textContent !== codeValue) codeAmount.textContent = codeValue; }); codeRows.forEach(function (row, index) { if (index >= codeSavings.length) row.remove(); });
    });
  }
  function applySnapshot(cart) {
    result = window.MDCCartSavingsModel.calculate(cart, window.MDCCartSavingsConfig);
    if (result.valid && result.complete) {
      result.checkoutTotal = cart.total_price;
      result.codeSavings = result.cartCodeSavings;
      result.beforeReductionTotal = cart.original_total_price - result.giftDiscountExcluded;
      result.paidDiscountTotal = result.beforeReductionTotal - result.checkoutTotal;
    }
    pending = false;
    mdcUpdateGiftDiscountBadges(mdcGiftBadgeCart = result.valid && result.complete ? cart : null, document.querySelector('#essential-cart-drawer-portal'));
    render();
    mdcCartLinePresent(result.valid && result.complete ? cart : null);
    cleanOrphanedProtection(cart);
    giftChoicePresent(cart);
  }
  var accept = window.MDCCartSavingsModel.latestOnly(applySnapshot, function () { pending = true; render(); }, function () { result = null; pending = false; mdcUpdateGiftDiscountBadges(mdcGiftBadgeCart = null, document.querySelector('#essential-cart-drawer-portal')); mdcCartLinePresent(null); render(); });
  // Only reuse a section rendered with this exact Shopify cart response.
  function bundledSnapshot(sections, items) {
    try {
      var source = sections && sections['mdc-cart-savings-data'];
      if (typeof source !== 'string' || !source.trim() || !Array.isArray(items)) return null;
      var html = new DOMParser().parseFromString(source, 'text/html');
      var node = html.querySelector('[data-mdc-savings-snapshot]');
      var cart = node && JSON.parse(node.textContent);
      var check = cart && window.MDCCartSavingsModel.calculate(cart, window.MDCCartSavingsConfig);
      if (!check || !check.valid || !check.complete || cart.items.length !== items.length) return null;
      var keys = new Set(items.map(function (item) { return item.key; }));
      if (keys.size !== items.length || !cart.items.every(function (item) {
        var actual = items.find(function (entry) { return entry.key === item.key; });
        return actual && actual.variant_id === item.variant_id && actual.quantity === item.quantity &&
          actual.original_price === item.original_price && actual.final_line_price === item.final_line_price;
      })) return null;
      return cart;
    } catch (_) { return null; }
  }
  function acceptBundledSnapshot(sections, items) {
    var cart = bundledSnapshot(sections, items);
    if (!cart) return false;
    clearTimeout(timer); timer = null;
    refreshQueued = false;
    accept.invalidate();
    applySnapshot(cart);
    return true;
  }
  async function readSnapshot() {
    var url = new URL(location.href);
    url.searchParams.delete('sections');
    url.searchParams.set('section_id', 'mdc-cart-savings-data');
    var response = await fetch(url.pathname + url.search, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Savings unavailable');
    var html = new DOMParser().parseFromString(await response.text(), 'text/html');
    return JSON.parse(html.querySelector('[data-mdc-savings-snapshot]').textContent);
  }
  var refreshFlight = null;
  var refreshQueued = false;
  function refresh() {
    clearTimeout(timer); timer = null;
    if (refreshFlight) {
      refreshQueued = true;
      accept.invalidate();
      return refreshFlight;
    }
    refreshFlight = (async function () {
      do {
        refreshQueued = false;
        await accept(readSnapshot);
      } while (refreshQueued);
    }()).finally(function () { refreshFlight = null; });
    return refreshFlight;
  }
  function schedule() { clearTimeout(timer); accept.invalidate(); timer = setTimeout(refresh, 100); }
  function mount() {
    if (document.querySelector('main .cart-page')) return;
    var footer = document.querySelector('#essential-cart-drawer-portal [data-essential-cart-element="cart-drawer-footer"]');
    var source = document.querySelector('template[data-mdc-savings-template]');
    var subtotal = footer && footer.querySelector('[data-essential-cart-element="subtotal-wrapper"]');
    if (footer && source && subtotal && !footer.querySelector('[data-mdc-cart-savings]')) {
      subtotal.before(source.content.cloneNode(true));
      render();
    }
  }
  function mdcLocalizeQuantityStatus() {
    var source = document.querySelector('[data-mdc-quantity-updated-label]');
    var portal = document.getElementById('essential-cart-drawer-portal');
    if (!source || !portal) return;
    var label = source.getAttribute('data-mdc-quantity-updated-label');
    if (!label || label === 'Quantity updated.') return;
    portal.querySelectorAll('[aria-live="polite"]').forEach(function (node) {
      if (node.childElementCount === 0 && node.textContent.trim() === 'Quantity updated.') {
        node.textContent = label;
      }
    });
  }
  var observer = new MutationObserver(function (records) {
    mdcLocalizeQuantityStatus();
    var relevant = records.some(function (record) {
      var feedbackTarget = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (feedbackTarget && feedbackTarget.closest('[data-mdc-gift-checkout-status],[data-mdc-gift-remove],[data-mdc-gift-error]')) return false;
      var feedbackNodes = Array.from(record.addedNodes).concat(Array.from(record.removedNodes));
      var hasFeedback = feedbackNodes.some(function (node) {
        return node.nodeType === 1 && node.matches('[data-mdc-gift-checkout-status],[data-mdc-gift-remove],[data-mdc-gift-error]');
      });
      if (record.type === 'childList' && hasFeedback && feedbackNodes.every(function (node) {
        return (node.nodeType === 3 && !node.textContent.trim()) ||
          (node.nodeType === 1 && node.matches('[data-mdc-gift-checkout-status],[data-mdc-gift-remove],[data-mdc-gift-error]'));
      })) return false;
      // Mounting our own panel must not trigger a second snapshot request.
      // Keep removals and all other cart mutations eligible for a refresh.
      var ownPanelAdded = false;
      var ownMountOnly = record.type === 'childList' && record.removedNodes.length === 0 &&
        record.addedNodes.length > 0 && Array.from(record.addedNodes).every(function (node) {
          if (node.nodeType === 3 && !node.textContent.trim()) return true;
          if (node.nodeType === 1 && node.matches('[data-mdc-cart-savings]')) {
            ownPanelAdded = true;
            return true;
          }
          return false;
        });
      if (ownMountOnly && ownPanelAdded) return false;
      if (Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) { return node.nodeType === 1 && node.matches('[data-mdc-cart-line-group]'); })) return false;
      var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return target && !target.closest('[data-mdc-cart-savings], [data-mdc-protection-status], [data-mdc-cart-line-group]') &&
        (target.closest('cart-items-component, #essential-cart-drawer-portal') ||
         Array.from(record.addedNodes).some(function (node) {
           return node.nodeType === 1 && (node.matches('cart-items-component, #essential-cart-drawer-portal') ||
             node.querySelector('cart-items-component, #essential-cart-drawer-portal'));
         }));
    });
    if (relevant) { mdcUpdateGiftDiscountBadges(mdcGiftBadgeCart, document.querySelector('#essential-cart-drawer-portal')); mount(); schedule(); }
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  var cartEventVersion = 0;
  import('@shopify/events').then(function (events) {
    [events.StandardEvents.cartLinesUpdate, events.StandardEvents.cartDiscountUpdate].forEach(function (name) {
      document.addEventListener(name, function (event) {
        accept.invalidate();
        var version = ++cartEventVersion;
        if (event.promise) event.promise.then(function (response) {
          if (version !== cartEventVersion) return;
          // The cart component resolves only after its new rows are rendered.
          if (!acceptBundledSnapshot(response?.detail?.sections, response?.detail?.items)) schedule();
        }, function () { if (version === cartEventVersion) schedule(); });
        else schedule();
      });
    });
  }).catch(function () {});
  document.addEventListener('essential-cart:update', schedule);
  document.addEventListener('mdc:cart-updated', schedule);
  // The initial load already calls refresh(); restore a BFCache page separately.
  window.addEventListener('pageshow', function (event) { if (event.persisted) schedule(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
  document.addEventListener('click', function (event) {
    if (!mdcCartLineBusy || !(event.target instanceof Element)) return;
    var button = event.target.closest('button, a, input[type="submit"]');
    if (button && (button.name === 'checkout' || /^(?:Paiement|Checkout|Pagar|الدفع)/.test(button.textContent.trim()))) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  window.MDCCartSavings = { refresh: refresh };
  mount();
  try {
    var initialNode = document.querySelector('[data-mdc-savings-snapshot]');
    var initialCart = initialNode && JSON.parse(initialNode.textContent);
    var initialResult = initialCart && window.MDCCartSavingsModel.calculate(initialCart, window.MDCCartSavingsConfig);
    if (initialResult && initialResult.valid && initialResult.complete) {
      giftChoiceCart = initialCart;
      mdcCartLinePresent(initialCart);
    }
  } catch (_) {}
  refresh();
}());










